/**
 * Chat session keys, kept in a dependency-free module so code that only needs
 * to clear them (e.g. the property switch in `shared/api`) doesn't have to pull
 * in the orth store and its socket setup.
 */

// Persist the open thread in sessionStorage so a page refresh restores it.
// `idle`/undefined clears it (thread closed / new chat).
export const OPEN_THREAD_SESSION_KEY = 'openThreadId';

/**
 * Threads belong to a single property, so the one left open before a farm
 * switch must not be restored after it — the reload would reopen a thread that
 * belongs to the account the user just left.
 */
export const clearOpenThread = () => {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(OPEN_THREAD_SESSION_KEY);
};
